export interface Conversation {
  id: string
  title?: string
  status: ConversationStatus;
  timestamp: string;
  messages: ConversationMessage[];
  createdAt: string;
  updatedAt: string;
}

export enum ConversationStatus {
  ACTIVE = "active",
  CLOSED = "closed",
}

export interface ConversationMessage {
  id: string
  sender: string;
  message: string;
  timestamp: string;
  options?: MessageOption[];
}

export interface MessageOption {
  id: string;
  title: string;
  description: string;
  image?: string;
  type?: MessageOptionType;
  flightDetails?: FlightDetails;
  eventDetails?: EventDetails;
  tourDetails?: TourDetails;
  accommodationDetails?: AccommodationDetails;
  articleDetails?: ArticleDetails;
}

export const enum MessageOptionType {
  FLIGHT = "flight",
  EVENT = "event",
  TOUR = "tour",
  ACCOMMODATION = "accommodation",
  ARTICLE = "article",
}

export interface ArticleDetails {
  link: string;
  summary: string;
  language: string;
  translationLink?: string;
}

export interface EventDetails {
  title: string;
  description: string;
  date: string;
  city: string;
  url: string;
  image: string;
}

export interface TourDetails {
  title: string;
  description?: string;
  duration?: number;
  price?: string;
  rating?: number;
  reviewCount?: number;
  url: string;
  image?: string;
  source: string;
}

export interface FlightDetails {
  airlines: string[];
  price: string;
  duration: string;
  stops: number;
  origin_airport: string;
  destination_airport: string;
  departure_time: string;
  departure_date: string;
  arrival_time: string;
  arrival_date: string;
  stops_detail: FlightStopDetails[];
  total_layover_minutes: number;
  // Round-trip return leg (optional)
  return_departure_date?: string;
  return_departure_time?: string;
  return_arrival_date?: string;
  return_arrival_time?: string;
  return_duration?: string;
  return_stops?: number;
  return_stops_detail?: FlightStopDetails[];
  return_origin_airport?: string;
  return_destination_airport?: string;
  return_total_layover_minutes?: number;
}

export interface AccommodationDetails {
  name: string;
  type: string;
  area: string;
  price_range: string;
  highlights: string[];
  url?: string;
}

export interface FlightStopDetails {
  index: number;
  airport: string;
  arrival_time: string;
  arrival_date: string;
  departure_time: string;
  departure_date: string;
  layover_minutes: string;
  // Duration of the flight segment that ARRIVES at this stop (leg prior to layover)
  flight_duration?: string;
}

export interface ChatMessage {
  id?: string;
  content: string;
  timestamp?: Date;
  images?: string[];
  options?: MessageOption[];
  isUser?: boolean;
}

export interface SendMessageRequest {
  message: string;
  conversationId?: string; // missing => start new conversation
  context?: any;
}

export interface SendMessageResponse {
  messages: ChatMessage[];    // last Agentic messages
  conversationId: string;
  status?: ConversationStatus;
}

export interface OrchestratorImage {
  url: string;
  caption?: string;
  altText?: string;
}
export interface OrchestratorMessage {
  id: string;
  timestamp: string;
  sender: "user" | "orchestrator";
  content: string;
  agentsInvolved?: string[];
  images?: OrchestratorImage[];
}

export interface OrchestratorConversation {
  conversationId: string;
  userId?: string;
  status: "active" | "closed" | string;
  messages: OrchestratorMessage[];
  leadScore?: number;
  userPreferences?: Record<string, unknown>;
}